export default "__VITE_ASSET__DrnECc9d__"